import { useState } from 'react';

import { getRosterIdentityMainLinkedIdentity } from '../../../util/identity';

/**
 * Handles address book records selection.
 *
 * @returns {{onRosterIdentityToggle: onRosterIdentityToggle, selectedRosterIdentities: *[], setWaldogramConfigOpen: React.Dispatch<React.SetStateAction<boolean>>, waldogramConfigOpen: boolean, onRosterIdentitySelect: onRosterIdentitySelect, isRosterIdentitySelectable: (function(*): boolean), isRosterIdentitySelected: (function(*): boolean), onRosterIdentityDeselect: onRosterIdentityDeselect}}
 */
const useAddressBookSelect = () => {
  const [selectedRosterIdentities, setSelectedRosterIdentities] = useState([]);
  const [waldogramConfigOpen, setWaldogramConfigOpen] = useState(false);

  const isRosterIdentitySelectable = rosterIdentity => {
    if (!rosterIdentity) {
      return false;
    }

    const mainIdentity = getRosterIdentityMainLinkedIdentity(rosterIdentity);

    return mainIdentity?.addresses?.records?.length > 0;
  };

  const isRosterIdentitySelected = rosterIdentity => {
    if (!rosterIdentity) {
      return false;
    }

    return selectedRosterIdentities.some(
      selectedRosterIdentity => selectedRosterIdentity.id === rosterIdentity.id,
    );
  };

  const onRosterIdentitySelect = rosterIdentity => {
    if (!rosterIdentity) {
      return;
    }

    if (
      isRosterIdentitySelected(rosterIdentity) ||
      !isRosterIdentitySelectable(rosterIdentity)
    ) {
      return;
    }

    setSelectedRosterIdentities(prev => [...prev, rosterIdentity]);
  };

  const onRosterIdentityDeselect = rosterIdentity => {
    if (!rosterIdentity) {
      return;
    }

    setSelectedRosterIdentities(prev =>
      prev.filter(
        selectedRosterIdentity =>
          selectedRosterIdentity.id !== rosterIdentity.id,
      ),
    );
  };

  const onRosterIdentityToggle = rosterIdentity => {
    if (!isRosterIdentitySelected(rosterIdentity)) {
      onRosterIdentitySelect(rosterIdentity);
    } else {
      onRosterIdentityDeselect(rosterIdentity);
    }
  };

  return {
    selectedRosterIdentities,
    isRosterIdentitySelectable,
    isRosterIdentitySelected,
    onRosterIdentitySelect,
    onRosterIdentityDeselect,
    onRosterIdentityToggle,
    waldogramConfigOpen,
    setWaldogramConfigOpen,
  };
};

export default useAddressBookSelect;
